import { render } from "./MobileSlide.vue?vue&type=template&id=fd25bd66&scoped=true"
import script from "./MobileSlide.vue?vue&type=script&lang=js"
export * from "./MobileSlide.vue?vue&type=script&lang=js"

import "./MobileSlide.vue?vue&type=style&index=0&id=fd25bd66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\McCoy\\Desktop\\Coding\\Work\\caby_landing_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd25bd66"]])

export default __exports__